import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';

var TimelineItem = function TimelineItem(props) {
  var _classNames, _classNames2, _context;

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      pkgPrefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps;

  var _a = getCompProps('TimelineItem', userDefaultProps, props),
      customizePrefixCls = _a.prefixCls,
      className = _a.className,
      color = _a.color,
      children = _a.children,
      pending = _a.pending,
      dot = _a.dot,
      mode = _a.mode,
      label = _a.label,
      labelWidth = _a.labelWidth,
      lineHeight = _a.lineHeight,
      restProps = __rest(_a, ["prefixCls", "className", "color", "children", "pending", "dot", "mode", "label", "labelWidth", "lineHeight"]);

  var prefixCls = getPrefixCls(pkgPrefixCls, 'timeline-item', customizePrefixCls);
  var itemClassName = classNames((_classNames = {}, _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, "pending", pending), _classNames), className);
  var hasColorClass = /blue|red|green|gray/.test(color || '');
  var dotClassName = classNames((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-dot"), true), _defineProperty(_classNames2, "custom", dot), _defineProperty(_classNames2, color, hasColorClass), _classNames2));
  var dotStyle = {
    top: lineHeight / 2,
    backgroundColor: color && !hasColorClass ? color : undefined
  };
  var labelStyle = mode !== 'alternate' ? _defineProperty({
    width: "".concat(labelWidth, "px")
  }, _concatInstanceProperty(_context = "margin".concat(mode === null || mode === void 0 ? void 0 : mode.substring(0, 1).toUpperCase())).call(_context, mode === null || mode === void 0 ? void 0 : mode.substring(1)), "-".concat(labelWidth, "px")) : {};
  return /*#__PURE__*/React.createElement("li", _extends({}, restProps, {
    className: itemClassName
  }), label && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-label"),
    style: _extends(_extends({}, labelStyle), {
      lineHeight: lineHeight + 'px'
    })
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-tail"),
    style: {
      marginTop: lineHeight - 2
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: dotClassName,
    style: dotStyle
  }, dot), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-content"),
    style: {
      lineHeight: lineHeight + 'px'
    }
  }, children));
};

export default TimelineItem;